// Возвращает URL'ы для подстановки в текстах политики/условий
// в зависимости от текущего домена.
export default function getPolicyLinks() {
  const host =
    typeof window !== "undefined" && window.location
      ? window.location.hostname.toLowerCase()
      : "";
  if (host.endsWith("wepurplay.com")) {
    return {
      gameSites: "https://wepurplay.com/",
      gameRules: "https://wepurplay.com/",
    };
  }
  if (host.endsWith("wepurplay.ru")) {
    return {
      gameSites: "https://wepurplay.ru/",
      gameRules: "https://wepurplay.ru/",
    };
  }
  return {
    gameSites: "https://in-touch.space/ , https://in-touch.space/game",
    gameRules: "https://in-touch.space/game/rules",
  };
}
